import { memo } from 'react';

import { QuestionCircleOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import cn from 'classnames';

import { useLanguage } from '@/shared/lib/hooks';

import { useGetColumnNameBySlugQuery } from '../../api/column-name.api';

import cls from './column-name.module.css';

interface ColumnNameProps {
    slug: string;
    shouldShowInfoIcon?: boolean;
    shouldShowSlug?: boolean;
}

export const ColumnName = memo(
    ({
        slug,
        shouldShowInfoIcon = true,
        shouldShowSlug = false,
    }: ColumnNameProps) => {
        const [language] = useLanguage();

        const { data, isLoading } = useGetColumnNameBySlugQuery({
            locale: language,
            slug,
        });

        const displayText = data?.title || slug;

        const popoverContent = !data?.content ? (
            <div>
                {/* eslint-disable-next-line i18next/no-literal-string */}
                <div className={cls.content}>Column name slug: {slug}</div>
            </div>
        ) : (
            <div>
                {data?.title && <div className={cls.title}>{data.title}</div>}
                <div className={cls.content}>{data.content}</div>
            </div>
        );

        return (
            <div className={cls.container}>
                <div>
                    {shouldShowSlug && (
                        <div className={cls.slug}>
                            {slug.replace('_scaled', '')}
                        </div>
                    )}
                    <div>{displayText}</div>
                </div>

                {shouldShowInfoIcon && !isLoading && (
                    <Popover
                        autoAdjustOverflow
                        content={popoverContent}
                        destroyTooltipOnHide
                        overlayClassName={cls.popover}
                        placement="bottom"
                        trigger={['click', 'hover']}
                    >
                        <span
                            className={cn(cls.helpTrigger, {
                                [cls.withSlug]: shouldShowSlug,
                            })}
                        >
                            <QuestionCircleOutlined style={{ fontSize: 14 }} />
                        </span>
                    </Popover>
                )}
            </div>
        );
    },
);

ColumnName.displayName = 'ColumnName';
